/* =============================================================
   D'BakerAid Recipes — index page filter logic
   - Reads data-filter on each .recipes-filter button
   - Matches against data-category on each .recipe-card
   - Toggles is-hidden class instead of display:none inline
   - Updates aria-pressed and is-active states
   ============================================================= */

(function () {
  'use strict';

  function init() {
    var filters = document.querySelectorAll('.recipes-filter');
    var cards = document.querySelectorAll('.recipe-card');
    var empty = document.getElementById('recipes-grid-empty');

    if (!filters.length || !cards.length) return;

    function applyFilter(value) {
      var visible = 0;
      cards.forEach(function (card) {
        var cat = card.getAttribute('data-category') || '';
        var match = value === 'all' || cat === value;
        if (match) {
          card.classList.remove('is-hidden');
          visible++;
        } else {
          card.classList.add('is-hidden');
        }
      });

      if (empty) {
        if (visible === 0) {
          empty.hidden = false;
        } else {
          empty.hidden = true;
        }
      }
    }

    function setActive(button) {
      filters.forEach(function (f) {
        f.classList.remove('is-active');
        f.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-filter') || 'all';
        setActive(button);
        applyFilter(value);
      });
    });

    // Support URL hash like #filter=Sweet so cards can deep-link
    var hash = window.location.hash.replace('#', '');
    if (hash.indexOf('filter=') === 0) {
      var target = decodeURIComponent(hash.split('=')[1] || '');
      var btn = Array.prototype.find.call(filters, function (f) {
        return f.getAttribute('data-filter') === target;
      });
      if (btn) {
        setActive(btn);
        applyFilter(target);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
